// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:1599px){.b2b-booking .book-cal{margin-left:0!important}}", ""]);
// Exports
module.exports = exports;
